module.exports = __webpack_public_path__ + "img/folderLink.212b39ba.svg";